import React from 'react';
import { Avatar, Row } from 'library/ui';

const ProfileImage = ({ image, imageId, initials }: { image?: string; imageId: string; initials?: string }) => {
    return (
        <Row justify="center">
            <span id={imageId}>
                <Avatar imageUrl={image} initials={initials} size={120} />
            </span>
        </Row>
    );
};

export default ProfileImage;
